import React from 'react';

// Components
import * as S from './Styled';

const Alert = ({ children, ...rest }) => (
  <S.Alert {...rest}>{children}</S.Alert>
);

export default Alert;
